const Loader = ({
  widthClass = "w-10",
  heightClass = "h-10",
  colorClass = "border-buttonColor",
}) => {
  return (
    <div className="w-full flex justify-center items-center">
      <svg
        className={`${widthClass} ${heightClass} ${colorClass} bg-transparent border-4 animate-spin rounded-full border-t-[white]`}
      />
    </div>
  );
};

export default Loader;
